// extracted by mini-css-extract-plugin
module.exports = {"aside":"d_f","list":"d_g","listItem":"d_h"};